module.exports = __webpack_public_path__ + "static/media/20210109_213551_265_IMG_1783.a6754bf1.jpg";